import { Injectable } from '@angular/core';

@Injectable()
export class CookieService {
    constructor() {}

    public getCookie(name: string) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([.$?*|{}()[]\/+^])/g, "\\$1") + "=([^;]*)"
        ));
        return matches ? JSON.parse(decodeURIComponent(matches[1])) : undefined;
    }

    public setCookie(name: string, value: any): void {
        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(JSON.stringify(value));
        updatedCookie += ";path=/" +
          ";domain=.dfos.kr" +
          ";expires=60*60*24" +
          ";";

        document.cookie = updatedCookie;
    }

    public deleteCookie(name: string): void {
        document.cookie = name + "=; expires=Thu, 01 Jan 1999 00:00:10 GMT;";
    }
}
